export default function DffProposalDetailData(props: { label: string; value: any }) {
    return (
        <div className="dff-proposal-detail-data">
            <div className="dff-proposal-detail-data-label">{props.label}</div>
            <div className="dff-proposal-detail-data-value">{props.value}</div>
        </div>
    );
}
